//UI REDUCERS
export const LOADING_ON = "LOADING_ON"; 
export const LOADING_OFF = "LOADING_OFF";
export const SET_THEME = "SET_THEME";

//USER REDUCERS
export const USER_ERROR = "USER_ERROR";
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_REGISTER = "USER_REGISTER";
export const GOOGLE_LOGIN = "GOOGLE_LOGIN";
export const CURRENT_USER = "CURRENT_USER";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";


//BOOK REDUCERS
export const GET_BOOK = "GET_BOOK";
export const SELECT_BOOK = "SELECT_BOOK";
export const GET_BOOKMARKS = "GET_BOOKMARKS";
export const GET_RESERVED = "GET_RESERVED";
export const GET_FAVORITES = "GET_FAVORITES";


//COLLECTION REDUCERS
export const GET_COLLECTION = "GET_COLLECTION";
export const SELECT_COLLECTION = "SELECT_COLLECTION";


//CATEGORY REDUCERS
export const SELECT_CATEGORY = "SELECT_CATEGORY";
export const GET_CATEGORY = "GET_CATEGORY";

//EBOOK REDUCERS
export const GET_EBOOK = "GET_EBOOK";

//REQUEST REDUCERS 
export const ADD_REQUEST = "ADD_REQUEST";
export const GET_REQUEST = "GET_REQUEST"
export const GET_REQUEST_BOOKS = "GET_REQUEST_BOOKS"

//TRANSACTION REDUCERS
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const GET_RETURNED_TRANSACTIONS = "GET_RETURNED_TRANSACTIONS";
export const GET_PENALTY_TRANSACTIONS = "GET_PENALTY_TRANSACTIONS";
export const RESET_TRANSACTIONS = "RESET_TRANSACTIONS";
export const GET_TRANSACT_BOOKS = "GET_TRANSACT_BOOKS";

//NUMBER OF TRANSACTIONS
export const GET_NUMBER = "GET_NUMBER";
export const GET_LATE_NUMBER = "GET_LATE_NUMBER";
export const GET_RETURN_NUMBER = "GET_RETURN_NUMBER";
export const GET_REQUEST_NUMBER = "GET_REQUEST_NUMBER";

